import { memo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Marker } from "react-mapbox-gl";

import {
  selectedCollectionSelector,
  visibleScheduledCollectionsSelector,
} from "../../reducers/matrixProfile/selectors";
import { setSelectedCollection } from "../../reducers/matrixProfile";
import { setZoomFromMouseEvent } from "../../reducers/map/thunkActions";

import { CollectionMarker } from "../ScheduledCollections/CollectionMarker";
import CollectionPopUp from "../ScheduledCollections/CollectionPopUp/";

export const ScheduledCollectionLayer = memo(() => {
  const scheduledCollections = useSelector(visibleScheduledCollectionsSelector);
  const dispatch = useDispatch();
  const collections = useSelector(selectedCollectionSelector);

  if (!Array.isArray(scheduledCollections)) return null;

  return (
    <>
      {scheduledCollections.map((collections, index) => {
        const firstCollection = collections[0];
        if (!firstCollection.stopLocation.coordinates) return null;

        return (
          <Marker
            coordinates={firstCollection.stopLocation.coordinates}
            anchor={"bottom"}
            key={index}
            onClick={() => {
              dispatch(setSelectedCollection(collections));
            }}
            onWheel={(e) => dispatch(setZoomFromMouseEvent(e))}
          >
            <CollectionMarker collections={collections} />
          </Marker>
        );
      })}
      {collections && collections[0]?.stopLocation?.coordinates && (
        <CollectionPopUp />
      )}
    </>
  );
});

export default ScheduledCollectionLayer;
